export default __webpack_public_path__ + "static/media/login-bg.d0505097.webp";